<script lang="ts">
  import { selectedOrgIdStore } from "$lib/stores/orgs";
  import Button from "$lib/ui/button/button.svelte";
  import { downloadExportedData } from "$lib/utils/api";
  import { toaster } from "$lib/utils/toaster";
  /**
   * Container component for security findings
   *
   * This component acts as a wrapper that coordinates between the PaginationState,
   * PaginationControls, and the DetectedIssuesList component, handling security-findings-specific logic.
   */

  import SensitiveDataTree from "./SensitiveDataTree.svelte";
  const orgId = $selectedOrgIdStore;
  let isDownloading = $state(false);

  const startDownloadExportedData = async (orgId: string | undefined) => {
    if (isDownloading) {
      return false;
    }

    if (!orgId) {
      toaster.error("Error downloading exported data", "Please select an organization");
      return;
    }

    isDownloading = true;

    try {
      console.log("Starting download exported data", orgId);
      const response = await downloadExportedData(orgId);
      if (response.status !== 200) {
        toaster.error("Error downloading exported data", "Please try again later");
        return;
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error downloading exported data", error);
      toaster.error("Error downloading exported data", "Please try again later");
    } finally {
      isDownloading = false;
    }
  };
</script>

<div class="flex flex-col gap-2">
  <div class="flex flex-col gap-2 items-end">
    <Button
      size="xs"
      variant="outline"
      on:click={() => startDownloadExportedData(orgId)}
      disabled={isDownloading}
      class="flex items-center gap-2"
    >
      {#if isDownloading}
        <span class="text-gray-400">Processing...</span>
      {:else}
        Download
      {/if}
    </Button>
    <span class="text-xs text-gray-500">Download all data in a zip file</span>
  </div>
  <SensitiveDataTree />
</div>
